var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.5.7-Queue-/-Registration---view-patient-in-upcoming",
    transform: "translate(-1102.000000, -82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(256.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(551.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(295.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6363281,3.87499996 C14.3704259,3.87523764 17.3974186,6.90223033 17.3976563,10.6363281 C17.3976563,12.2783073 16.8123556,13.7835821 15.8390093,14.9548975 L19.9419418,19.0580583 C20.1860195,19.302136 20.1860195,19.6978641 19.9419418,19.9419418 C19.6978641,20.1860195 19.302136,20.1860195 19.0580583,19.9419418 L14.9548975,15.8390093 C13.7835821,16.8123556 12.2783073,17.3976563 10.6363281,17.3976563 C6.90214969,17.3976563 3.87499996,14.3705065 3.87499996,10.6363281 C3.87499996,6.90214969 6.90214969,3.87499996 10.6363281,3.87499996 Z M10.6362883,5.12499996 C7.59250563,5.12499996 5.12499997,7.59250563 5.12499997,10.6363281 C5.12499997,13.6801506 7.59250563,16.1476563 10.6363281,16.1476563 C13.6801506,16.1476563 16.1476563,13.6801506 16.1476563,10.6363679 C16.1474625,7.59260369 13.6800525,5.12519371 10.6362883,5.12499996 Z",
    id: "Combined-Shape",
    fill: "#666666",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-icon.2886067c.svg";
export { ForwardRef as ReactComponent };